import {lazy} from 'react';

// Authentication and account management components
export const Login = lazy(() => import("../../pages/auth/Login"));
export const Register = lazy(() => import("../../pages/auth/Register"));
export const RegisterSaas = lazy(() => import("../../pages/auth/RegisterSaas"));
export const VerifyEmail = lazy(() => import("../../pages/auth/VerifyEmail"));
export const ResetPassword = lazy(() => import("../../pages/auth/ResetPassword"));
export const ChangePassword = lazy(() => import("../../pages/auth/ChangePassword"));
export const ActivateAccount = lazy(() => import("../../pages/auth/ActivateAccount"));
export const ActivateParentAccount = lazy(() => import("../../pages/auth/ActivateParentAccount"));
export const GrantProductAccessToStudentPage = lazy(() => import("../../pages/auth/GrantProductAccessToStudentPage"));
export const LoginError = lazy(() => import("../../pages/auth/LoginError"));